<div class="custom-breadcrumb">
  <span [ngClass]="type === 'dashboard' ? 'dashboard-item' : 'item'" *ngFor="let item of items;let last = last;let i = index">
    <span class="txt" (click)="onSelect(item, i)">
      {{item}}
    </span>
    <span *ngIf="!last" class="icon">
      <i aria-hidden="true" class="fa fa-angle-right icon"></i>
    </span>
  </span>
</div>
